import {Quest} from './Quest.js';
import {Player} from './Player.js';

import type {GameAnalytics as GA} from 'gameanalytics';
import {ProgressionStatus} from '../utils/game-analytics-enums.js';
import {messageConsole} from '../components/message-controller.js';
declare var GameAnalytics: typeof GA;

// NPC class
export class NPC {
    name: string;
    quests: Quest[];

    constructor(name: string) {
        this.name = name;
        this.quests = [];
    }

    /**
     * Assigns a quest to a player
     * @param player the player to assign the quest to
     * @param quest the quest to assign to the player
     */
    assignQuest(player: Player, quest: Quest): void {
        const time = player.timeSinceLastFinishedQuest(quest);
        const hour = 1000 * 60 * 60;
        if (time && time < hour) {
            const minutes = Math.floor((hour - time) / (1000 * 60));
            messageConsole.addMessage(`Quest complete! Come back in ${minutes} minutes.`);
            return;
        }

        if (player.level < quest.requiredLevel) {
            messageConsole.addMessage(
                `You need to be level ${quest.requiredLevel} for this quest!`
            );
            return;
        }

        if (!player.hasQuest(quest)) {
            player.acceptQuest(quest);
            quest.onAssigned.notify();
            messageConsole.addMessage(`New quest: ${quest.description}`);
            GameAnalytics.addProgressionEvent(ProgressionStatus.Start, 'quest', quest.id);
        } else {
            if (!player.tryCompleteQuest(quest)) {
                return;
            } else {
                messageConsole.addMessage(`You completed: ${quest.description}`);
                GameAnalytics.addProgressionEvent(
                    ProgressionStatus.Complete,
                    'quest',
                    quest.id
                );
            }
        }
    }
}
